

export const Banner =[
    {
        "id":1,
        "img":["./banner1.png","./banner2.png","./banner3.png","./banner4.png","./banner5.png"],
      
     }
    ]